import debounce from 'lodash-decorators/debounce';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { isInFullScreen } from 'shared/selectors/player';
import { updateWindowSize } from 'widget/redux/client/actions/window-size';

@connect(
  state => ({
    isInFullScreen: isInFullScreen(state),
    windowSize: state.windowSize,
  }),
  {
    updateWindowSize,
  },
)
export default class WindowSize extends React.Component {
  static propTypes = {
    isInFullScreen: PropTypes.bool.isRequired,
    windowSize: PropTypes.object.isRequired,
    updateWindowSize: PropTypes.func.isRequired,
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateSize);

    // For cases, when editor don`t show iFrame from not selected page at mobile mode
    this.updateWidgetSizeInterval = setInterval(this.updateSize, 200);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateSize);

    if (this.updateWidgetSizeInterval) {
      clearInterval(this.updateWidgetSizeInterval);
    }
  }

  updateWidgetSizeInterval = null;

  updateSize = () => {
    // Need to wait for setting isInFullScreen to store
    // TODO use isFullScreenRequested and remove timeout
    setTimeout(() => {
      this._updateSize();
    });
  };

  @debounce(100)
  _updateSize() {
    if (!window.innerWidth || this.props.isInFullScreen) {
      return;
    }

    if (this.updateWidgetSizeInterval) {
      clearInterval(this.updateWidgetSizeInterval);
    }

    const nextWindowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    if (!_.isEqual(nextWindowSize, this.props.windowSize)) {
      this.props.updateWindowSize(nextWindowSize);
    }
  }

  render() {
    return null;
  }
}
